import React, { Component} from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import actions from 'actions';
import { push } from 'redux-router';
import DisciplineList from 'components/Admin/Discipline/ListDisciplines';
import Toolbar from 'components/Admin/Discipline/Toolbar';

const {
  loadAdminDisciplinesSaga,
  showDeleteDisciplinesConfirmationModal
} = actions;

class Disciplines extends Component {
  static propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    dispatch: PropTypes.func.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      discipline_ids: [],
      page: props.page || 1,
      query: {
        title: '',
        order: {
          created_at: 'desc'
        },
        ...props.query
      }
    }
  }

  componentWillMount = () => {
    this.loadDisciplines();
  }

  deleteDisciplines = () => {

    if(this.state.discipline_ids.length > 0)
      this.props.deleteDisciplines(this.state.discipline_ids)
  }

  onChangePage = (page = 1) => {
    this.setState({
      page
    }, this.loadDisciplines);
  }

  checkedDisciplineIds = (discipline_id) => {
    var ids = _.assign(this.state.discipline_ids),
      index = this.state.discipline_ids.indexOf(discipline_id);

    if(index == -1) {
      ids.push(discipline_id)
    } else {
      ids.splice(index, 1)
    }
    this.setState({ discipline_ids: ids })
  }

  loadDisciplines = () => this.props.loadDisciplines(this.state.page, this.state.query)

  changeQuery = (query, timeout = 500) => {
    this.setState({ query }, () => {
      if(this.timer){
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(this.loadDisciplines, timeout)
    })
  }

  onOrderChange = (field = 'created_at', order = 'desc') => {
    const query = {
      ...this.state.query,
      order: {
        [field]: order
      }
    }
    this.changeQuery(query, 0);
  }

  onChangeQuery = (field, value) => {
    const query = {...this.state.query, ...{ [field]: value }};
    this.setState({ page: 1 }, () => {
      this.changeQuery(query)
    });
  }

  render() {
    const {
      deleteDisciplines,
      state,
      onChangeQuery,
      onDateRangeChange
    } = this;
    return (
      <main className="site--width clearfix container_statistics">
        <div className="container_admin_sponsor">
        </div>
        <Toolbar
          filterProps={{
            ...state,
            onDateRangeChange,
            onChangeQuery
          }}
          toolsProps={{
            count: this.props.count,
            deleteDisciplines
          }}
        />
        <div className="admin_sponsors_table admin_table">
          <DisciplineList
            disciplines={this.props.disciplines}
            navigateToDiscipline={this.props.navigateToDiscipline}
            checkedDisciplineIds={this.checkedDisciplineIds}
            discipline_ids={this.state.discipline_ids}
            onOrderChange={this.onOrderChange}
            query={this.state.query}
            paginationProps={{
              onChangePage: this.onChangePage,
              page: this.state.page,
              total_pages: this.props.total_pages
            }}
          />
        </div>
      </main>
    );
  }
}

function mapStateToProps(state) {
  return {
    disciplines: state.disciplines.admin.list.values,
    count: state.disciplines.admin.list.count,
    total_pages: state.disciplines.admin.list.total_pages,
    page: state.disciplines.admin.list.page,
    query: state.disciplines.admin.list.query
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch: dispatch,
    navigateToDiscipline: (id) => dispatch(push(`/disciplines/${id}`)),
    deleteDisciplines: (discipline_ids) => dispatch(showDeleteDisciplinesConfirmationModal(discipline_ids)),
    loadDisciplines: (page, query) => dispatch(loadAdminDisciplinesSaga(page, query))
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Disciplines);



// WEBPACK FOOTER //
// ./src/containers/Admin/Discipline/Disciplines.jsx